export const activitiesItemSelectEvent = 'search:activity-search:click';
export const autocompleteFocusEvent = 'search:autocomplete:focus';
export const autocompleteBlurEvent = 'search:autocomplete:blur';
